// Reducer
const INITIAL_STATE = {
  slots: [],
  articleHeight: 50,
};

export default function (state = INITIAL_STATE) {
  return state;
}
/* eslint-enable no-case-declarations */
